import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const items = [
  {
    title: 'Audiencia Calificada',
    feedback: 'Llegamos al segmento deportivo y lifestyle que practica pádel y consume contenido premium en streaming y redes.',
  },
  {
    title: 'Contenido de Autor',
    feedback: 'No hacemos reportajes genéricos; creamos historias de competencia, comunidad y estilo de vida alrededor del torneo.',
  },
  {
    title: 'Conversión de Marca',
    feedback: 'Los patrocinadores no solo ven un logo; escuchan una recomendación en la voz de Yeraldine Marrero y la autoridad de TNO Network.',
  },
];

const PorQueTNO = () => {
  const theme = useTheme();

  return (
    <Box>
      <Box marginBottom={4}>
        <Typography variant="h4" fontWeight={700} align="left" gutterBottom>
          ¿Por qué TNO Network
          <br />
          para tu evento de pádel?
        </Typography>
      </Box>
      <Grid container spacing={3}>
        {items.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              width="100%"
              height="100%"
              data-aos="fade-up"
              component={Card}
              display="flex"
              flexDirection="column"
              sx={{ borderTop: 4, borderColor: theme.palette.primary.main }}
            >
              <CardContent sx={{ flex: 1 }}>
                <Typography variant="h6" fontWeight={700} gutterBottom color="primary">
                  {item.title}
                </Typography>
                <Typography color="textSecondary">{item.feedback}</Typography>
              </CardContent>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PorQueTNO;
